import { ModuleWithProviders, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VersionModalModule } from '@shared/modals/version-modal/version-modal.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
    declarations: [AppComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        VersionModalModule,
        NgxSpinnerModule,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}

@NgModule({})
export class VerificaAutenticidadeSharedModule {
    static forRoot(): ModuleWithProviders<AppModule> {
        return {
            ngModule: AppModule,
        };
    }
}
